import types from '@/vuex/vinculos-documento/actions-types'
import documentos from '@/utils/documentos'

const actions = {
  [types.INICIALIZAR_DADOS_VINCULOS_DOCUMENTO]: async ({ commit, dispatch }, payload) => {
    dispatch(types.GET_LISTA_VINCULOS_DOCUMENTO, {idDocumento: payload.idDocumento})
    if (payload.idDocumentoAgregador) dispatch(types.GET_DOCUMENTO_AGREGADOR, {idDocumentoAgregador: payload.idDocumentoAgregador})
    else commit(types.SET_DOCUMENTO_AGREGADOR, { documentoAgregador: undefined })
  },
  [types.GET_LISTA_VINCULOS_DOCUMENTO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando vínculos do documento' }, {root: true})
    try {
      commit(types.SET_LISTA_VINCULOS_DOCUMENTO, { listaVinculosDocumento: [] })
      const response = await documentos.getListaVinculosDocumento(payload.idDocumento)
      commit(types.SET_LISTA_VINCULOS_DOCUMENTO, { listaVinculosDocumento: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível obter os vínculos do documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando vínculos do documento' }, {root: true})
    }
  },
  [types.GET_DOCUMENTO_AGREGADOR]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento agregador' }, {root: true})
    try {
      const response = await documentos.getDocument(payload.idDocumentoAgregador, false)
      commit(types.SET_DOCUMENTO_AGREGADOR, { documentoAgregador: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar o documento agregador' }, {root: true})
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento agregador' }, {root: true})
    }
  },
  [types.SET_DOCUMENTO_AGREGADOR]: ({ commit }, payload) => {
    commit(types.SET_DOCUMENTO_AGREGADOR, payload)
  },
  [types.DESAPENSAR_DOCUMENTO]: async ({ commit, dispatch }, payload) => {
    const confirmacaoCallback = async () => {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Desapensando documentos' }, {root: true})
      try {
        await documentos.desapensarDocumentos(payload.documentoPai.idDocumento, payload.documentoFilho.idDocumento)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documentos desapensados com sucesso' }, {root: true})
        dispatch(types.GET_LISTA_VINCULOS_DOCUMENTO, {idDocumento: payload.documentoPai.idDocumento})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível desapensar os documentos' }, {root: true})
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Desapensando documentos' }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Desapensar os documentos?',
      textoConteudo: `O ${payload.documentoFilho.tipo.toLowerCase()} número ${payload.documentoFilho.numero} será desapensado do ${payload.documentoPai.tipo.toLowerCase()} número ${payload.documentoPai.numero}.`,
      textoNao: 'Cancelar',
      textoSim: 'Desapensar',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },
  [types.DESANEXAR_DOCUMENTO]: async ({ commit, dispatch }, payload) => {
    const confirmacaoCallback = async () => {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Desanexando documentos' }, {root: true})
      try {
        await documentos.desapensarDocumentos(payload.documentoPai.idDocumento, payload.documentoFilho.idDocumento)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documentos desanexados com sucesso' }, {root: true})
        dispatch(types.GET_LISTA_VINCULOS_DOCUMENTO, {idDocumento: payload.documentoPai.idDocumento})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível desanexar os documentos' }, {root: true})
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Desanexando documentos' }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Desanexar os documentos?',
      textoConteudo: `O ${payload.documentoFilho.tipo.toLowerCase()} número ${payload.documentoFilho.numero} será desanexado do ${payload.documentoPai.tipo.toLowerCase()} número ${payload.documentoPai.numero}.`,
      textoNao: 'Cancelar',
      textoSim: 'Desanexar',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/vinculos-documento/actions.js